const DontStopBelievin = [
	'[Verse 1]',
	'Just a small town girl, living in a lonely world',
	'She took the midnight train going anywhere',
	'Just a city boy, born and raised in south Detroit',
	'He took the midnight train going anywhere',
	'',
	'A singer in a smoky room, a smell of wine and cheap perfume',
	'For a smile they can share the night, it goes on and on and on and on',
	'',
	'[Chorus]',
	'Strangers waiting up and down the boulevard',
	'Their shadows searching in the night',
	'Streetlights, people, living just to find emotion',
	'Hiding, somewhere in the night',
	'',
	'[Verse 2]',
	'Working hard to get my fill, everybody wants a thrill',
	'Paying anything to roll the dice, just one more time',
	'Some will win, some will lose, some were born to sing the blues',
	'Oh, the movie never ends; it goes on and on and on and on',
	'',
	'[Chorus]',
	'Strangers waiting up and down the boulevard',
	'Their shadows searching in the night',
	'Streetlights, people, living just to find emotion',
	'Hiding, somewhere in the night',
	'',
	'[Outro]',
	"Don't stop believing, hold on to the feeling",
	'Streetlight people',
	"Don't stop believing, hold oooooooon",
	'Streetlight people',
	"Don't stop believing, hold on to the feeling",
	'Streetlight people',
];

export default DontStopBelievin;
